import { render, staticRenderFns } from "./HomeKPI.vue?vue&type=template&id=6612b496&"
import script from "./HomeKPI.vue?vue&type=script&lang=js&"
export * from "./HomeKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports